module.exports = __webpack_public_path__ + "img/IMG_8945.b64f2df1.jpg";